<div class="terms-content">
    <h1 class="fw-bold mb-2 display-6">Privacy Policy</h1>
    <p class="text-secondary fst-italic mb-4">Last Updated: January 8, 2026</p>
    <section class="mb-5">
        <h4 class="fw-bold mb-3 h5">1. Information We Collect</h4>
        <p class="text-muted leading-relaxed">
            We collect information you provide directly to us, such as when you create an account,
            subscribe to
            a newsletter, or contact support.
        </p>
        <ul class="text-muted mt-3">
            <li class="mb-3">
                <strong class="text-dark">Account Information:</strong> Name, email address, and profile
                details.
            </li>
            <li class="mb-3">
                <strong class="text-dark">Payment Information:</strong> Transaction history and billing
                details (processed via third-party
                providers).
            </li>
            <li>
                <strong class="text-dark">Usage Data:</strong> Information about how you interact with
                our Service.
            </li>
        </ul>
    </section>

    <section class="mb-5">
        <h4 class="fw-bold mb-3 h5">2. How We Use Your Information</h4>
        <p class="text-muted leading-relaxed">
            We use the information we collect to:
        </p>
        <ul class="text-muted mt-3">
            <li class="mb-2">Provide, maintain, and improve our Service.</li>
            <li class="mb-2">Process transactions and send related information.</li>
            <li class="mb-2">Send you technical notices, updates, and support messages.</li>
            <li>Respond to your comments and questions.</li>
        </ul>
    </section>

    <section class="mb-5">
        <h4 class="fw-bold mb-3 h5">3. Third-Party Services</h4>
        <p class="text-muted leading-relaxed">
            We use third-party services for payment processing (e.g., PayPal, Stripe) and analytics
            (e.g., Google
            Analytics). These third parties have access to your information only to perform these tasks
            on our
            behalf and are obligated not to disclose or use it for any other purpose.
        </p>
    </section>

    <section class="mb-5">
        <h4 class="fw-bold mb-3 h5">4. Data Security</h4>
        <p class="text-muted leading-relaxed">
            We implement reasonable measures to help protect information about you from loss, theft,
            misuse,
            and unauthorized access.
        </p>
    </section>

    <section class="mb-5">
        <h4 class="fw-bold mb-3 h5">5. Cookies</h4>
        <p class="text-muted leading-relaxed">
            We use cookies and similar technologies to collect information about your browsing
            activities and to
            distinguish you from other users of our Service.
        </p>
    </section>

    <section class="mb-5">
        <h4 class="fw-bold mb-3 h5">6. Contact Us</h4>
        <p class="text-muted leading-relaxed">
            If you have any questions about this Privacy Policy, please contact us at
            homepagepublic@gmail.com.
        </p>
    </section>
</div>